/**
 * A órbita — a assinatura visual do app, portada do mockup
 * (docs/fidelidade/design/support.js): uma elipse rotacionada com a esfera
 * laranja percorrendo a borda. "A esfera laranja é sempre a moeda."
 */

function ponto(cx: number, cy: number, rx: number, ry: number, rot: number, t: number) {
  const r = (rot * Math.PI) / 180;
  return {
    x: cx + rx * Math.cos(t) * Math.cos(r) - ry * Math.sin(t) * Math.sin(r),
    y: cy + rx * Math.cos(t) * Math.sin(r) + ry * Math.sin(t) * Math.cos(r),
  };
}

function arco(
  cx: number,
  cy: number,
  rx: number,
  ry: number,
  rot: number,
  t0: number,
  frac: number,
): string {
  const n = Math.max(2, Math.round(120 * frac));
  let d = '';
  for (let i = 0; i <= n; i++) {
    const p = ponto(cx, cy, rx, ry, rot, t0 + (frac * 2 * Math.PI * i) / n);
    d += (i ? 'L' : 'M') + p.x.toFixed(1) + ' ' + p.y.toFixed(1);
  }
  return d;
}

/** O símbolo da marca em miniatura: elipse fechada + esfera. */
export function LogoOrbita({ tamanho = 26 }: { tamanho?: number }) {
  const h = (tamanho * 20) / 26;
  return (
    <svg width={tamanho} height={h} viewBox="0 0 26 20">
      <g transform="rotate(-25 13 10)">
        <ellipse cx="13" cy="10" rx="10" ry="6" fill="none" stroke="var(--ink)" strokeWidth="1.6" />
        <circle cx="23" cy="10" r="2.4" fill="var(--accent)" />
      </g>
    </svg>
  );
}

/** A órbita aberta do estado vazio — `frac` do caminho percorrido. */
export function OrbitaAberta({ frac = 0.72 }: { frac?: number }) {
  const d = arco(120, 85, 105, 62, -25, Math.PI, frac);
  const esfera = ponto(120, 85, 105, 62, -25, Math.PI + frac * 2 * Math.PI);
  return (
    <svg viewBox="0 0 240 170" style={{ width: 240, maxWidth: '70vw' }}>
      <path d={d} fill="none" stroke="var(--ink)" strokeWidth="2" />
      <circle cx={esfera.x} cy={esfera.y} r="8" fill="var(--accent)" />
    </svg>
  );
}

/** A elipse fantasma que atravessa o topo da Carteira, como no mockup. */
export function OrbitaDeFundo() {
  return (
    <svg
      viewBox="0 0 500 400"
      style={{
        position: 'absolute',
        top: -60,
        right: -140,
        width: 500,
        pointerEvents: 'none',
      }}
    >
      <ellipse
        cx="250"
        cy="200"
        rx="230"
        ry="138"
        transform="rotate(-25 250 200)"
        fill="none"
        stroke="rgba(20,18,15,.04)"
        strokeWidth="1.5"
      />
    </svg>
  );
}

/** A bolinha laranja que é sempre a moeda. */
export function Moeda({ tamanho = 8 }: { tamanho?: number }) {
  return (
    <span
      style={{
        width: tamanho,
        height: tamanho,
        borderRadius: '50%',
        background: 'var(--accent)',
        display: 'inline-block',
        flex: 'none',
      }}
    />
  );
}
